import React from 'react'
import _ from 'lodash'
import renderHtml from 'react-render-html'

const BkFlowRoomDetailsSimplified = props => {
	const {
		renderRoomDescription,
		renderRoomLongDescription
	} = props

	return (
		<div className="bk-flow-room__details-content room-details-simplified">
			{ !_.isEmpty(renderRoomLongDescription) ?
				<div className="description">{renderHtml(renderRoomLongDescription)}</div>
			: !_.isEmpty(renderRoomDescription) ?
				renderRoomDescription
			: null}
		</div>
	)
}

export default BkFlowRoomDetailsSimplified


// WEBPACK FOOTER //
// ./src/components/room/room-details/layouts/BkFlowRoomDetailsSimplified.js